import i18n from '@/libs/i18n'
import alerts from '../alerts'
import statusTypes from './status-types'

const deliveryDomain = {
  mixins: [alerts],

  data() {
    return {
      deliverySupplierEnum: {
        APP99: 'APP99',
        FOOD99: 'FOOD99',
        UBER: 'UBER',
      },
      deliveryFeeEnum: {
        SINGLE_FEE: 'SingleFee',
        FEE_PER_KILOMETER: 'FeePerKilometer',
      },
    }
  },

  computed: {
    deliverySupplierLabel() {
      return {
        APP99: i18n.t('99'),
        FOOD99: i18n.t('99Food'),
        UBER: i18n.t('Uber'),
      }
    },
    deliveryFeeLabel() {
      return {
        SingleFee: i18n.t('Única'),
        FeePerKilometer: i18n.t('Por quilômetro'),
      }
    },
  },

  methods: {
    deliverySupplierOptions() {
      return [
        { value: 'APP99', label: this.$t('99') },
        { value: 'FOOD99', label: this.$t('99Food') },
        { value: 'UBER', label: this.$t('Uber') },
      ]
    },

    async mxChangeDeliveryStatus(
      sale,
      { selectedMotoboyId = null, onStartWithMotoboy } = {}
    ) {
      const { PENDING, IN_PROGRESS, PREPARING } = statusTypes.computed.deliveryStatusEnum()
      const types = {
        [PENDING]: {
          endpoint: 'prepare',
          dialogMessage: this.$t('Pendente -> Preparando'),
        },
        [PREPARING]: {
          endpoint: 'start',
          dialogMessage: this.$t('Preparando -> Entregando'),
        },
        [IN_PROGRESS]: {
          endpoint: 'finish',
          dialogMessage: this.$t('Entregando -> Entregue'),
        },
      }

      const { id, deliveryStatus } = sale
      if (!types[deliveryStatus]) return null

      const { endpoint, dialogMessage } = types[deliveryStatus]
      // Ao preparar, a loja assume a entrega: o backend cancela as solicitações automáticas
      // aos fornecedores de entrega e não as faz mais. Avisa quando a venda está nesse fluxo.
      const autoDeliveryState = String(sale.autoDeliveryState || '').toLowerCase()
      const inAutoDelivery =
        ['waiting', 'dispatching', 'supplierrequested', 'supplieraccepted'].includes(
          autoDeliveryState
        ) || !!(sale.deliveryDispatches || sale.dispatches || []).length
      const text =
        deliveryStatus === PENDING && inAutoDelivery
          ? `${dialogMessage}. ${this.$t('DELIVERY.AUTO_DISPATCH.PREPARE_CANCELS_AUTO_DELIVERY')}`
          : dialogMessage
      const confirmed = await this.confirm({
        title: this.$t('Alterar o status da entrega?'),
        text,
      })
      if (confirmed === undefined || confirmed === false) {
        return null
      }

      // Starting the delivery of an order that already has a Motoboy assigned
      // must drive the Motoboy's presence to Unavailable (start-delivery flow).
      if (deliveryStatus === PREPARING && selectedMotoboyId && onStartWithMotoboy) {
        return onStartWithMotoboy(String(selectedMotoboyId))
      }

      const { data } = await this.$http.patch(
        `/api/sales/pay-box-sale/delivery/${endpoint}/${id}`
      )
      return data
    },
    async mxAskDeliveryService(sale, deliverySupplier) {
      const { id } = sale

      const { data } = await this.$http.post(
        `/api/sales/pay-box-sale/delivery/estimate/${id}`,
        { deliverySupplier },
      )
      return data
    },
  },
}

export default deliveryDomain
